import React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface JoinGuardProps {
    children: React.ReactNode;
}

/**
 * 회원가입 플로우를 순서대로 진행하도록 보호하는 컴포넌트
 *
 * 우선순위:
 * 1. temporaryToken이 없으면 /auth/login으로 리다이렉트
 * 2. agreements가 없으면 /join/agreement로 리다이렉트
 * 3. nickname이 없으면 /join/nickname으로 리다이렉트
 *
 * @param children - 보호할 컴포넌트
 */
const JoinGuard: React.FC<JoinGuardProps> = ({ children }) => {
    const location = useLocation();
    const currentPath = location.pathname;

    // 필요한 데이터 가져오기
    const temporaryToken = localStorage.getItem("temporaryToken");
    const agreements = sessionStorage.getItem("agreements");
    const nickname = sessionStorage.getItem("nickname");

    // 1. 임시 토큰이 없으면 로그인 페이지로 리다이렉트
    if (!temporaryToken) {
        console.log("임시 토큰이 없어 로그인 페이지로 리다이렉트합니다.");
        return <Navigate to="/auth/login" replace />;
    }

    // 2. 현재 경로에 따른 리다이렉트 처리
    if (currentPath === "/join/nickname" && !agreements) {
        return <Navigate to="/join/agreement" replace />;
    }

    if (currentPath === "/join/userinfo") {
        if (!agreements) {
            return <Navigate to="/join/agreement" replace />;
        }

        if (!nickname) {
            return <Navigate to="/join/nickname" replace />;
        }
    }

    // 모든 검증을 통과하면 children 렌더링
    return <>{children}</>;
};

export default JoinGuard;
